(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duo-design-consultation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('duo-design-consultation')) {
    customElements.define('duo-design-consultation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const steps = [...this.querySelectorAll('.dc-step')];
        if (!form || !steps.length) return;
        form.classList.add('dc-enhanced');
        form.noValidate = true;
        this.querySelectorAll('.dc-next-actions, .dc-progress').forEach(el => { el.hidden = false; });
        this.currentStep = 1;
        const show = (number, focus = true) => {
          this.currentStep = number;
          steps.forEach(step => { step.hidden = Number(step.dataset.step) !== number; });
          this.querySelector('[data-step-number]').textContent = `${this.dataset.stepLabel} ${number} / ${steps.length}`;
          this.querySelector('[data-step-title]').textContent = steps[number - 1].dataset.title;
          this.querySelectorAll('.dc-progress-bars i').forEach((bar, i) => bar.classList.toggle('is-active', i < number));
          if (focus) steps[number - 1].querySelector('legend').focus();
        };
        const check = step => {
          const controls = [...step.querySelectorAll('input, select, textarea')];
          controls.forEach(control => {
            if (control.required && ['text', 'tel', 'textarea'].includes(control.type)) control.value = control.value.trim();
          });
          return controls.find(control => !control.checkValidity());
        };
        this.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => {
          const invalid = check(steps[this.currentStep - 1]);
          if (invalid) { invalid.focus(); invalid.reportValidity(); return; }
          show(Number(button.dataset.next));
        }));
        this.querySelectorAll('[data-back]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.back))));
        const zone = this.querySelector('[data-zone]');
        let virtualZone = '';
        const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if ([...zone.options].some(option => option.value === detected)) virtualZone = detected;
        const getToday = () => {
          const timezone = zone.value.includes('/') ? zone.value : undefined;
          const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
          return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
        };
        const refreshMin = () => this.querySelectorAll('[data-date]').forEach(input => { input.min = getToday(); });
        zone.addEventListener('change', () => { virtualZone = zone.value; refreshMin(); });
        this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', () => {
          const inPerson = radio.value.startsWith('In person');
          this.querySelector('[data-location]').hidden = !inPerson;
          zone.value = inPerson ? 'America/Vancouver' : virtualZone;
          [...zone.options].forEach(option => { option.disabled = inPerson && option.value !== 'America/Vancouver'; });
          refreshMin();
        }));
        const secondDate = this.querySelector('[data-date="2"]');
        this.querySelectorAll('[data-date], [data-time]').forEach(input => input.addEventListener('input', () => secondDate.setCustomValidity('')));
        const params = new URLSearchParams(location.search);
        this.querySelectorAll('[data-utm]').forEach(input => { input.value = (params.get(input.dataset.utm) || '').slice(0, 300); });
        form.addEventListener('submit', event => {
          if (this.currentStep < 3) {
            event.preventDefault();
            const next = steps[this.currentStep - 1].querySelector('[data-next]');
            if (next) next.click();
            return;
          }
          refreshMin();
          secondDate.setCustomValidity('');
          const firstDate = this.querySelector('[data-date="1"]');
          const firstTime = this.querySelector('[data-time="1"]');
          const secondTime = this.querySelector('[data-time="2"]');
          if (firstDate.value && firstTime.value && firstDate.value === secondDate.value && firstTime.value === secondTime.value) secondDate.setCustomValidity(this.dataset.duplicateError);
          for (const step of steps) {
            const invalid = check(step);
            if (invalid) { event.preventDefault(); show(Number(step.dataset.step), false); invalid.focus(); invalid.reportValidity(); return; }
          }
          if (this.hasAttribute('data-preview')) {
            event.preventDefault();
            const notice = this.querySelector('.dc-preview-result');
            notice.textContent = this.dataset.previewMessage;
            notice.hidden = false;
            notice.focus();
          }
        });
        zone.value = virtualZone;
        refreshMin();
        show(1, false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
